import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faJava, faPython, faJs, faDocker, faGolang } from '@fortawesome/free-brands-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

interface LanguageIconProps {
  icon: string;
  className?: string;
}

export default function LanguageIcon({ icon, className = "" }: LanguageIconProps) {
  const iconMap: Record<string, IconDefinition> = {
    java: faJava,
    python: faPython,
    javascript: faJs,
    docker: faDocker,
    golang: faGolang,
  };

  // Custom C icon
  if (icon === 'c') {
    return (
      <svg className={className} viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm2.5 13.5c-.69.69-1.64 1.1-2.7 1.1-2.1 0-3.8-1.7-3.8-3.8s1.7-3.8 3.8-3.8c1.06 0 2.01.41 2.7 1.1l-1.06 1.06c-.43-.43-1.02-.7-1.64-.7-1.27 0-2.3 1.03-2.3 2.3s1.03 2.3 2.3 2.3c.62 0 1.21-.27 1.64-.7L14.5 15.5z"/>
      </svg>
    );
  }

  // Custom C++ icon
  if (icon === 'cpp') {
    return (
      <svg className={className} viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm.5 13.5c-.69.69-1.64 1.1-2.7 1.1-2.1 0-3.8-1.7-3.8-3.8s1.7-3.8 3.8-3.8c1.06 0 2.01.41 2.7 1.1l-1.06 1.06c-.43-.43-1.02-.7-1.64-.7-1.27 0-2.3 1.03-2.3 2.3s1.03 2.3 2.3 2.3c.62 0 1.21-.27 1.64-.7L12.5 15.5zm3.5-2.5h-.75V14h-.5v-1H14v-.5h1v-1h.5v1H16v.5zm2.5 0h-.75V14h-.5v-1H16.5v-.5h1v-1h.5v1H19v.5z"/>
      </svg>
    );
  }

  // Custom Kotlin icon (SVG)
  if (icon === 'kotlin') {
    return (
      <svg className={className} viewBox="-3 -3 30 30" fill="currentColor">
        <path d="M0 24l12-12L0 0h12l12 12-12 12H0z"/>
      </svg>
    );
  }

  const iconDef = iconMap[icon];

  if (!iconDef) {
    return null;
  }

  return <FontAwesomeIcon icon={iconDef} className={className} />;
}
